function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import { Honeybadger } from "@honeybadger-io/react";
var serviceName = "vino-checkout";
var reportData = process.env.HONEYBADGER_REPORTDATA === "true";

// NODE_ENV is "production" in every Netlify/webpack production build, so staging
// and production were indistinguishable. VM_ENV is the real deploy target, and the
// market suffix separates AU from SG in a project both regions report into.
// Must also be the configured default: errors the SDK captures itself (uncaught
// exceptions, unhandled rejections) carry no environment, so they fall back here.
var environment = "".concat(process.env.VM_ENV || process.env.NODE_ENV, "[").concat(process.env.VM_MARKET, "]");
var config = {
  apiKey: process.env.HONEYBADGER_API_KEY,
  environment: environment,
  developmentEnvironments: ["development"],
  reportData: reportData,
  filters: ["password", "creditcard", "token", "PATToken", "PAT_TOKEN", "authorization"]
};
var isProd = process.env.NODE_ENV !== "development";
var enabledHoneyBager = isProd ? Honeybadger.configure(config) : null;
export var ErrorNotifier = {
  notify: function notify(error, context) {
    if (enabledHoneyBager) Honeybadger.notify(error, context);
  },
  setContext: function setContext(context) {
    if (enabledHoneyBager) Honeybadger.setContext(context);
  }
};

// Honeybadger tags are a comma-separated string, so a label with spaces would
// read as several tags. Slugify for the tag; `source` keeps the prose form.
export var sourceTag = function sourceTag(source) {
  return source.trim().toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
};
// Honeybadger's own `filters` match key names in structured context, but the
// request body reaches us as one opaque JSON string - so card tokens and PAT
// JWTs were stored verbatim on every /process-payment fault. Redact by key
// before the body leaves the function. The cart id is the browser's credential.
var sensitiveKey = /^(pat_?token|token|access_?token|refresh_?token|authorization|password|creditcard|card_?number|cvv|cvc|verification_value|cart_?id)$/i;
var _redact = function redact(value) {
  if (Array.isArray(value)) return value.map(_redact);
  if (value && _typeof(value) === "object") {
    return Object.entries(value).reduce(function (acc, _ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        val = _ref2[1];
      acc[key] = sensitiveKey.test(key) ? "[FILTERED]" : _redact(val);
      return acc;
    }, {});
  }
  return value;
};
export { _redact as redact };
var redactParams = function redactParams(params) {
  return _redact(params);
};

// A body we can't parse could hold anything, so drop it rather than guess.
var redactBody = function redactBody(body) {
  if (!body) return null;
  try {
    return JSON.stringify(_redact(JSON.parse(body)));
  } catch (_unused) {
    return "[UNPARSEABLE - FILTERED]";
  }
};

// An axios message only says "status code 422" - the upstream's own body is the
// only thing that says why. It was going to console.log and never to the fault.
var upstreamResponse = function upstreamResponse(error) {
  var data = error && error.response && error.response.data;
  return data === undefined ? {} : {
    upstreamResponse: _redact(data)
  };
};

// For log lines. A raw Axios error prints its request config, and with it the
// credentials in the headers.
export var toLoggable = function toLoggable(error) {
  if (!error || _typeof(error) !== "object") return {
    message: String(error)
  };
  var loggable = {
    message: error.message
  };
  if (typeof error.name === "string") loggable.name = error.name;
  if (error.code !== undefined) loggable.code = error.code;
  if (error.response) {
    loggable.status = error.response.status;
    if (error.response.data !== undefined) loggable.data = _redact(error.response.data);
  }
  return loggable;
};
export var contextBuilder = function contextBuilder(ctx, evt) {
  return _objectSpread(_objectSpread({}, ctx && {
    requestId: ctx && ctx.awsRequestId,
    user_id: ctx && ctx.clientContext && ctx.clientContext.user && ctx.clientContext.user.sub
  }), evt && {
    queryStringParameters: redactParams(evt.queryStringParameters),
    multiValueQueryStringParameters: redactParams(evt.multiValueQueryStringParameters),
    path: evt.path,
    method: evt.httpMethod,
    requestBody: redactBody(evt.body)
  });
};
export var errorDataBuilder = function errorDataBuilder(type, statusCode, error, context, event, customMessage) {
  return {
    tags: "".concat(process.env.VM_MARKET, ", ").concat(type, ", ").concat(serviceName, ", ").concat(statusCode),
    name: "[".concat(type, "][").concat(serviceName, "]"),
    message: "[".concat(statusCode, "] ").concat(customMessage || error),
    context: _objectSpread(_objectSpread({}, contextBuilder(context, event)), upstreamResponse(error)),
    environment: environment,
    params: redactParams(event && event.queryStringParameters || event && event.multiValueQueryStringParameters)
  };
};

// Service-layer reporting. Handlers pass `event`, so their faults carry the
// path, method and body that say where they came from; a service has none of
// that and was filing `[API][vino-checkout] [500] AxiosError` with no context
// at all - indistinguishable from every other service failure.
//
// Only for services that swallow the error, where this is the sole record.
// Where a service rethrows and its handler reports, this would be a second,
// thinner fault for one failure - drop the notify there instead.
export var reportServiceError = function reportServiceError(error, statusCode, source) {
  var data = errorDataBuilder("API", statusCode, error);
  ErrorNotifier.notify(error, _objectSpread(_objectSpread({}, data), {}, {
    tags: "".concat(data.tags, ", ").concat(sourceTag(source)),
    context: _objectSpread(_objectSpread({}, data.context), {}, {
      source: source
    })
  }));
};